// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"469":"48d9f250","764":"562dd5de","888":"c365c6e9"}[chunkId] + ".chunk.css";
};